module.exports = __webpack_public_path__ + "img/07_maska_pyatno_2.e3319c0.svg";